var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndexIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 336 336",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M272 0H115.16a9.916 9.916 0 0 0-5.88 2.32L45.04 66.8a8 8 0 0 0-2.48 5.8v241.96c.022 11.832 9.608 21.418 21.44 21.44h208c11.693-.02 21.222-9.389 21.44-21.08V21.44C293.418 9.608 283.832.022 272 0zm-81.96 16h47v75.04l-16.68-26.6a8 8 0 0 0-13.72 0l-16.6 26.48V16zm-82.96 11.4v22.28c-.022 8.187-6.653 14.818-14.84 14.84H69.96l37.12-37.12zm170.2 287.32A5.32 5.32 0 0 1 272 320H64a5.319 5.319 0 0 1-5.48-5.28V80.68h33.72c17.103-.044 30.956-13.897 31-31V16h50.64v81.68a15.996 15.996 0 0 0 3.36 9.96 12.8 12.8 0 0 0 14.2 4.2l.6-.2a18.962 18.962 0 0 0 9.08-8l12.44-20 12.44 20a18.962 18.962 0 0 0 9.08 8 12.841 12.841 0 0 0 14.8-4 15.996 15.996 0 0 0 3.36-9.96V16H272a5.32 5.32 0 0 1 5.28 5.24v293.48z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48 267.2h-141a8 8 0 0 0 0 16h141a8 8 0 0 0 0-16zM238.48 227.8h-141a8 8 0 0 0 0 16h141a8 8 0 0 0 0-16zM238.48 188.4h-141a8 8 0 0 0 0 16h141a8 8 0 0 0 0-16zM238.48 149h-141a8 8 0 0 0 0 16h141a8 8 0 0 0 0-16z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexIcon);
export default __webpack_public_path__ + "static/media/index-icon.ae2c33ad1afed784e621796a15b75ae3.svg";
export { ForwardRef as ReactComponent };